import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface AddRecordButtonProps {
  label: string;
  onClick: () => void;
}

const AddRecordButton = ({ label, onClick }: AddRecordButtonProps) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    className="tw-h-8 tw-gap-1 tw-text-xs"
    onClick={onClick}
    aria-label={`Add ${label} record`}
  >
    <Plus className="tw-h-3.5 tw-w-3.5" /> Add record
  </Button>
);

export default AddRecordButton;
